import React from 'react'

import { FormFieldStatus, InputField } from '@gousto-internal/citrus-react'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

export const StreetInput = () => (
  <Field name="street">
    {({ field, meta }: FieldProps) => (
      <InputField
        id={field.name}
        data-testid="street"
        label="Street"
        status={meta.touched && meta.error ? FormFieldStatus.Error : undefined}
        validationMessage={meta.touched ? meta.error : undefined}
        maxLength={35}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...field}
      />
    )}
  </Field>
)
